import Login from "~/pages/Login";
import BrokerDashboard from "~/pages/broker-portal/BrokerDashboard";
import BrokerRisk from "~/pages/broker-portal/BrokerRisk";
import BrokerSubmissionEntry from "../pages/broker-portal/BrokerRisk/BrokerSubmissionEntry";
import BrokerFirmOrderEditPage from "~/pages/broker-portal/BrokerFirmOrderEdit";
import BrokerAmendmentEntryPage from "~/pages/broker-portal/BrokerAmendmentEntry";
import BrokerSubscriptionAgreementEntry from "~/pages/broker-portal/BrokerSubscriptionAgreementEntry";
import BrokerMidTermAdjustmentEntry from "~/pages/broker-portal/BrokerMidTermAdjustmentEntry";
import InsurerDashboard from "~/pages/insurer-portal/InsurerDashboard";
import InsurerRisk from "~/pages/insurer-portal/InsurerRisk";
import InsurerSecurityDashboard from "~/pages/insurer-portal/InsurerSecurityDashboard";
import UnauthorisedPage from "~/pages/UnauthorisedPage";
import ClientAssignmentDashboard from "~/pages/broker-portal/ClientAssignmentDashboard";
import FacilityManager from "~/pages/broker-portal/FacilityManager";
import InsurerEntity from "~/pages/broker-portal/InsurerEntity";
import Reports from "~/pages/Reports";
import ObligorPanel from "~/pages/broker-portal/ObligorPanel";
import PolicyWarning from "~/pages/PolicyWarning";
import ClientAndEntityManager from "../pages/broker-portal/ClientAndEntityManager.vue";
import BrokerManualSubmissionTrackerEntry from "../pages/broker-portal/BrokerRisk/ManualSubmissionTracker/BrokerManualSubmissionTrackerEntry.vue";

export default [
    {
        path: '/login',
        alias: '/',
        name: 'login',
        meta: {
            layout: 'login'
        },
        component: Login,
    },
    {
        path: '/agent/obligors',
        name: 'obligor-panel',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker'
            ]
        },
        component: ObligorPanel,
    },
    {
        path: '/agent/dashboard',
        name: 'broker-dashboard',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
                'client',
                'placing-broker',
                'producing-broker'
            ]
        },
        component: BrokerDashboard
    },
    {
        path: '/agent/risk/:id/subscription-agreements/:subscriptionAgreementId?',
        name: 'subscription-agreement-entry',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
                'placing-broker',
                'producing-broker'
            ]
        },
        component: BrokerSubscriptionAgreementEntry
    },
    {
        path: '/agent/risk/:id/mid-term-adjustment/:midTermAdjustmentId?',
        name: 'mid-term-adjustment-entry',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
                'placing-broker',
                'producing-broker'
            ]
        },
        component: BrokerMidTermAdjustmentEntry
    },
    {
        path: '/agent/risk/:id/:step?',
        name: 'broker-risk',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
                'client',
                'placing-broker',
                'producing-broker'
            ]
        },
        component: BrokerRisk
    },
    {
        path: '/agent/manual-submission/:id',
        name: 'manual-submission-risk',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'placing-broker',
            ]
        },
        component: BrokerRisk
    },
    {
        path: '/agent/risk/new',
        name: 'broker-new-risk',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
                'client',
                'placing-broker',
                'producing-broker'
            ]
        },
        component: BrokerSubmissionEntry,
        props: true
    },
    {
        path: '/agent/facility-manager',
        name: 'facility-manager',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'placing-broker'
            ]
        },
        component: FacilityManager
    },
    {
        path: '/agent/client-and-entity-manager',
        name: 'client-and-entity-manager',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker'
            ]
        },
        component: ClientAndEntityManager
    },
    {
        path: '/agent/insurer-entity',
        name: 'insurer-entity',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker'
            ]
        },
        component: InsurerEntity
    },
    {
        path: '/insurer/reports',
        name: 'insurer-reports',
        meta: {
            layout: 'default',
            scopes: [
                'captive-insurer',
                'insurer'
            ]
        },
        component: Reports
    },
    {
        path: '/agent/reports',
        name: 'agent-reports',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
                'client',
                'placing-broker',
                'producing-broker'
            ]
        },
        component: Reports
    },
    {
        path: '/agent/firm-order/:id/edit',
        name: 'broker-firm-order-edit',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
                'client',
                'placing-broker',
                'producing-broker'
            ]
        },
        component: BrokerFirmOrderEditPage
    },
    {
        path: '/agent/amendment-entry/:id',
        name: 'broker-amendment-entry',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
                'client',
                'placing-broker',
                'producing-broker'
            ]
        },
        component: BrokerAmendmentEntryPage
    },
    {
        path: '/agent/client-assignment',
        name: 'client-assignment',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'admin-producing-broker',
            ]
        },
        component: ClientAssignmentDashboard,
    },
    {
        path: '/insurer/dashboard',
        name: 'insurer-dashboard',
        meta: {
            layout: 'default',
            scopes: [
                'captive-insurer',
                'insurer'
            ]
        },
        component: InsurerDashboard,
    },
    {
        path: '/insurer/risk/:id',
        name: 'insurer-risk',
        meta: {
            layout: 'default',
            scopes: [
                'captive-insurer',
                'insurer'
            ]
        },
        component: InsurerRisk
    },
    {
        path: '/insurer/risk/:id/edit',
        name: 'insurer-edit-risk',
        meta: {
            layout: 'default',
            scopes: [
                'captive-insurer',
                'insurer'
            ]
        },
        component: InsurerRisk
    },
    {
        path: '/insurer/security',
        name: 'insurer-security',
        meta: {
            layout: 'default',
            scopes: ['insurer']
        },
        component: InsurerSecurityDashboard,
    },
    {
        path: '/unauthorised',
        name: 'unauthorised',
        component: UnauthorisedPage
    },
    {
        path: '/policy-warning',
        name: 'policy-warning',
        meta: {
            layout: 'default'
        },
        component: PolicyWarning,
    },
    {
        path: '/agent/mst/new',
        name: 'broker-new-mst',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'placing-broker',
            ]
        },
        component: BrokerManualSubmissionTrackerEntry,
        props: true
    },
    {
        path: '/agent/mst/:id',
        name: 'broker-edit-mst',
        meta: {
            layout: 'default',
            scopes: [
                'admin-placing-broker',
                'placing-broker',
            ]
        },
        component: BrokerManualSubmissionTrackerEntry,
        props: true
    }
];
